export const meshList = {
	BalancePoles: {
		name: "Balance_poles",
		color: 0xffece5,
		castShadows: true,
		receiveShadows: true,
		judder: true
	},
	Borders: {
		name: "Borders",
		color: 0xffcead,
		castShadows: true,
		judder: true
	},
	Building: {
		name: "Building",
		color: 0xc0c0c0,
		castShadows: true,
		flyBy: true
	},
	Ceiling: {
		name: "Ceiling",
		gradient: {
			colors: [0x3cf0, 0x487ec, 0x7438ff],
			stops: [0, 0.4, 1]
		},
		castShadows: true,
		judder: true
	},
	ChairStands: {
		name: "Chair_stands",
		color: 0xffcbad,
		receiveShadows: true,
		judder: true
	},
	CloudsBack: {
		name: "Clouds_back",
		texture: "clouds-back",
		transparent: true,
		rotate: true,
		rotationSpeed: 0.0003
	},
	CloudsFront: {
		name: "Clouds_front",
		texture: "clouds-front",
		transparent: true,
		rotate: true,
		rotationSpeed: 0.0003
	},
	DoubleDoors: {
		name: "Double_doors",
		gradient: {
			colors: [0xa333ff, 0x5452ff, 0x8280ff],
			stops: [0, 0.2, 1]
		},
		castShadows: true,
		receiveShadows: true,
		judder: true
	},
	Frame: {
		name: "Frame",
		color: 0x23bfe7,
		castShadows: true,
		judder: true
	},
	FrameRight: {
		name: "Frame_right",
		gradient: {
			colors: [0x6b4f7, 0x23bfe7, 0x23bfe7],
			stops: [0, 0.7, 1]
		},
		castShadows: true,
		judder: true
	},
	Gubbins: {
		name: "Gubbins",
		texture: "gubbins",
		transparent: true,
		castShadows: true,
		receiveShadows: true,
		judder: true
	},
	InternalDoor: {
		name: "Internal_door",
		gradient: {
			colors: [0x1fa9ff, 0x3d91ff, 0xc252ff],
			stops: [0, 0, 1]
		},
		castShadows: true,
		judder: true
	},
	Logo: {
		name: "Logo",
		color: 0x1d1d3a,
		alphaMap: "logo",
		doubleSided: true,
		castShadows: true,
		judder: true
	},
	Outline: {
		name: "Outline",
		color: 0x8245f2,
		judder: true
	},
	PostLarge: {
		name: "Post_large",
		color: 0x999999,
		castShadows: true,
		flyBy: true
	},
	PostMedium: {
		name: "Post_medium",
		color: 0x999999,
		castShadows: true,
		flyBy: true
	},
	PostSmall: {
		name: "Post_small",
		color: 0x999999,
		castShadows: true,
		flyBy: true
	},
	Runway: {
		name: "Runway",
		gradient: {
			colors: [0xffcbad, 0xffe4d6, 0xffecbd],
			stops: [0, 0.4, 1]
		},
		castShadows: true,
		receiveShadows: true,
		judder: true
	},
	RunwaySides: {
		name: "Runway_sides",
		gradient: {
			colors: [0xab3f7, 0xbaf8, 0x5b89ff],
			stops: [0, 0.8, 1]
		},
		receiveShadows: true,
		judder: true
	},
	SeatRight: {
		name: "Seat_right",
		color: 0xfffcdb,
		castShadows: true,
		judder: true
	},
	SeatsLeft: {
		name: "Seats_left",
		color: 0xfffcdb,
		castShadows: true,
		receiveShadows: true,
		judder: true
	},
	Shrubbery: {
		name: "Shrubbery",
		texture: "shrubbery",
		transparent: true,
		rotate: true,
		rotationSpeed: 0.006,
		position: {
			y: 6.4
		}
	},
	Sky: {
		name: "Sky",
		gradient: {
			colors: [0xa347ff, 0x1fa9ff, 0xffc29e],
			stops: [0, 0.4, 1]
		}
	},
	SkylineBack: {
		name: "Skyline_back",
		gradient: {
			colors: [0xb870ff, 0xb094ff, 0x557682],
			stops: [0, 0.5, 1]
		},
		alphaMap: "skyline-back",
		rotate: true,
		rotationSpeed: -0.003
	},
	SkylineFront: {
		name: "Skyline_front",
		gradient: {
			colors: [0x235bcd, 0x7c22cc, 0x3c0070],
			stops: [0, 0.9, 1]
		},
		alphaMap: "skyline-front",
		rotate: true,
		rotationSpeed: 0.005
	},
	Sun: {
		name: "Sun",
		texture: "sun",
		transparent: true,
		rotate: true,
		rotationSpeed: 6e-7
	},
};
